// Theme entry point.
// Custom scripts are jQuery-based IIFEs that run on import and rely on
// globals (jQuery, gsap, ScrollTrigger, ajaxurl) enqueued separately in PHP.
import './components/scripts.js';
import './components/performances-filter.js';
